import script from "./TheAbandonedCarts.vue?vue&type=script&setup=true&lang=js"
export * from "./TheAbandonedCarts.vue?vue&type=script&setup=true&lang=js"

import "./TheAbandonedCarts.vue?vue&type=style&index=0&id=0d855922&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d855922"]])

export default __exports__